const section7Data = [
  {
    id: 1,
    imgName: 'Section7Support1.png',
    title: 'ID-verified profiles',
    description: 'Our partners are constantly working on dealing with fake accounts!',
  },
  {
    id: 2,
    imgName: 'Section7Support2.png',
    title: 'Email Support',
    description: 'Our support service is ready to help with any task.',
  },
  {
    id: 3,
    imgName: 'Section7Support3.png',
    title: 'Multilingual service',
    description: 'Apolo is available in 8 different languages.',
  },
]

export default section7Data
